import React from "react"
import classNames from "classnames"
import * as R from "ramda"

const transparentImgSrc = "https://api.run24hrs.com/media/images/240x240-00000000.png"

export const IndividualMedal = ({medal, middle}) => {
  const badeBoxClass = classNames({ 'mobile-middle-badgebox': middle}, 'badge-box')
  console.log(R.pathOr("default", ['finish_run'], medal))
  const medalImg = {
    default: transparentImgSrc,
    true: R.path(["color_medal"], medal),
    false: transparentImgSrc
  }
  return <div className="column">
    <img
      className="top-frame"
      src="https://api.run24hrs.com/media/images/sFrameHead419x118.png"
    />
    <div
      style={{backgroundImage: "url(https://api.run24hrs.com/media/images/sFrameBody419x246.png)"}}
      className={badeBoxClass}
    >
      <div
        className="column badge-wrapper"
      >
        <img
          style={{width: "60%"}}
          src={medalImg[R.pathOr("default", ['finish_run'], medal)]}
        />{" "}
      </div>
    </div>
    <img
      className="bottom-frame"
      src="https://api.run24hrs.com/media/images/sFrameBottom419x118.png"
    />
  </div>
}


// WEBPACK FOOTER //
// /opt/build/repo/src/components/IndividualMedal.js